<template>
  <el-row style="width: 100%;margin-top: 115px;">
    <!--  轮播图  -->
    <el-row style="height: 240px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="240px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')'}" class="top-img-class">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <!--  新闻资讯  -->
    <el-row style="width: 94%;margin: 20px 0 0 3%;text-align: left;">
      <el-row v-show="!showDetail" v-if="newsList.length > 0" style="width: 100%;">
        <el-row v-for="(item, i) in newsList" :key="i"  style="width: 100%;margin-bottom: 20px;">
          <el-row style="width: 100%;height: 232px;text-align: left;background-color: #eaf4f7;">
            <el-image :src="getImageUrl(item.newsCover)" class="img-class" fit="cover" @click.native="changeRoute('/news', item.newsType, item.id)"></el-image>
            <el-row style="width: 98%;margin-left: 1%;height: 50px;margin-top: 10px;display: flex;">
              <el-row class="text-class" @click.native="changeRoute('/news', item.id)">
                {{item.titleName}}
              </el-row>
              <el-row style="width: 30%;font-size: 14px;text-align: right;color: #000;">
                {{item.createTime}}
              </el-row>
            </el-row>
          </el-row>
        </el-row>
        <el-row style="height: 40px;width: 100%;text-align: right;margin-top: 20px;">
          <el-pagination background layout="total, prev, pager, next" :page-size="15" @current-change="pageChange"
                         :current-page="pageInfo.pageNum" :page-count="pageInfo.pages" :total="pageInfo.total" />
        </el-row>
      </el-row>
      <el-row v-show="showDetail">
        <el-row style="font-size: 20px;text-align: center;line-height: 32px;font-weight: bold;">{{titleName}}</el-row>
        <el-row style="font-size: 16px;height: 50px;line-height: 50px;text-align: right;color: gray;">发布日期: {{createTime}}</el-row>
        <el-row v-for="(detail, i) in detailList" :key="i">
          <div v-if="detail.contentType === 0" style="line-height: 30px;white-space: pre-wrap;text-align: justify;text-indent: 2em;">{{detail.content}}</div>
          <el-row v-else-if="detail.contentType === 1" style="margin-top: 16px;margin-bottom: 16px;width: 100%;">
            <el-image :src="getImageUrl(detail.content)"></el-image>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
import axios from 'axios'
export default {
  name: 'NewsPage',
  data() {
    return {
      imgList: [require('../../assets/img/news/news.jpg')],
      dataList: [
        {
          id: '71',
          name: '公司新闻',
          type: 0
        },
        {
          id: '72',
          name: '行业动态',
          type: 1
        }
      ],
      selMenu: 0,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pages: 0
      },
      newsList: [],
      titleName: '',
      createTime: '',
      detailList: [],
      showDetail: false,
      dict: {'71': 0, '72': 1}
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    this.dealIntoPage()
  },
  watch: {
    $route: {
      handler() {
        let page = this.$route.query.page
        if (page) {
          this.clickMenu(this.dict[page])
        } else {
          this.clickMenu(0)
        }
        this.dealIntoPage()
      },
      deep: true
    }
  },
  methods: {
    clickMenu(i) {
      if (this.selMenu === i) {
        return
      }
      this.selMenu = i
      if (this.$route.query.id) {
        this.$router.push({path: this.$route.path})
      } else {
        this.doQuery(1)
        this.showDetail = false
      }
    },
    doQuery(page) {
      let param = {page: page, rows: 5, newsType: this.dataList[this.selMenu].type}
      this.$api.newsManage.getNewsInfo(param).then(res => {
        this.newsList = res.data.rows
        this.pageInfo.total = res.data.total
        this.pageInfo.pageNum = res.data.pageNum
        this.pageInfo.pages = res.data.pages
      })
    },
    clickNews(id) {
      this.$router.push({path: this.$route.path, query: {id: id}})
    },
    getImageUrl(id) {
      return '/myApi/newsInfo/getImageById?id=' + id
    },
    pageChange(page) {
      this.doQuery(page)
    },
    dealIntoPage() {
      if (this.$route.query.id) {
        let param = {id: this.$route.query.id}
        this.$api.newsManage.getNewsDetail(param).then(res => {
          if (res.code !== 500) {
            this.detailList = res.data.detail
            this.titleName = res.data.titleName
            this.createTime = res.data.createTime
            this.selMenu = res.data.newsType
            this.showDetail = true
          }
        })
      } else {
        this.doQuery(1)
        this.showDetail = false
      }
    },
    changeRoute(path, type, id) {
      this.showDetail = true
      const page = type === 0? '71': '72'
      this.$router.push({path: path, query: {page: page, id: id}})
    }
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .top-img-class {
    width: 100%;
    height: 240px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .menu-class {
     width: 85%;
     margin-top: 10px;
     height: 40px;
     line-height: 40px;
     background-color: #efefef;
     color: #000000;
     cursor: pointer;
   }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .title-class {
    height: 60px;
    line-height: 60px;
  }
  .title-class:hover {
    cursor: pointer;
    color: #00bf86;
  }
  .img-class {
    width: calc(100% - 4px);
    margin-left: 2px;
    margin-top: 2px;
    height: 180px;
  }
  .text-class {
    width: 70%;
    text-align: left;
    color: #000000;
    cursor: pointer;
    white-space:nowrap;
    text-overflow:ellipsis;
    overflow: hidden;
  }
  .text-class:hover {
    color: #00bf86;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsPage.vue